import { Slot, Slottable } from '@radix-ui/react-slot';
import { forwardRef } from 'react';

import { IconButton } from '../../../core-components';
import { wrapSlottableChildren } from '../../../utils';

import type { ForwardRefRenderFunction, PropsWithChildren } from 'react';

type VideoComponentProps = PropsWithChildren<{
  asChild?: boolean;
}>;

const VideoComponentRenderFunction: ForwardRefRenderFunction<
  HTMLDivElement,
  VideoComponentProps
> = (props, ref?) => {
  const { children, asChild, ...rest } = props;

  const Element = asChild ? Slot : 'div';

  return (
    <Element
      {...rest}
      ref={ref}
      className="group/icon-button relative block overflow-hidden rounded-sm"
    >
      <Slottable>
        {wrapSlottableChildren(asChild, children, children => (
          <div className="overlay-black/20">{children}</div>
        ))}
      </Slottable>

      <IconButton
        asChild
        iconName="play"
        size="md"
        variant="primary"
        on="image"
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      >
        <div />
      </IconButton>
    </Element>
  );
};

export const VideoComponent = forwardRef<HTMLDivElement, VideoComponentProps>(
  VideoComponentRenderFunction,
);
